module.exports = __webpack_public_path__ + "static/media/wave-strike.1fe6dbab.svg";